module.exports = __webpack_public_path__ + "img/icon-ativo.45113e9c.png";